// Calendar geometry shared by the Poultry Timeline's headers, bars and scroll.
// Date-only arithmetic uses UTC ordinals so a daylight-saving change is never
// a fraction of a day on the chart.
const DAY_MS = 86_400_000;
export const POULTRY_TIMELINE_GUTTER = 145;
export const POULTRY_TIMELINE_PHONE_WEEK = 120;

export function poultryTimelineDay(iso: string): number {
  return Date.parse(`${iso}T00:00:00Z`) / DAY_MS;
}

export function poultryTimelineDate(day: number): string {
  return new Date(day * DAY_MS).toISOString().slice(0, 10);
}

export function poultryTimelineFourMonths(today: string) {
  const start = `${today.slice(0, 7)}-01`;
  const endDate = new Date(`${start}T00:00:00Z`);
  endDate.setUTCMonth(endDate.getUTCMonth() + 4);
  const end = endDate.toISOString().slice(0, 10);
  return {start, end, days: poultryTimelineDay(end) - poultryTimelineDay(start)};
}

export function poultryTimelineViewport({
  today,
  start,
  dataEnd,
  contentWidth,
  phone,
}: {
  today: string;
  start: string;
  dataEnd: string;
  contentWidth: number;
  phone: boolean;
}) {
  const window = poultryTimelineFourMonths(today);
  const end = !phone && window.end > dataEnd ? window.end : dataEnd;
  const totalDays = Math.max(1, poultryTimelineDay(end) - poultryTimelineDay(start));
  const canvasWidth = Math.max(0, contentWidth - POULTRY_TIMELINE_GUTTER);
  const dayWidth = !phone && canvasWidth > 0 ? canvasWidth / window.days : POULTRY_TIMELINE_PHONE_WEEK / 7;
  const dateWidth = totalDays * dayWidth;
  const width = POULTRY_TIMELINE_GUTTER + dateWidth;
  const initialDay = poultryTimelineDay(phone ? today : window.start) - poultryTimelineDay(start);
  const initialTarget = phone
    ? Math.floor((initialDay * dayWidth - canvasWidth * 0.12) / POULTRY_TIMELINE_PHONE_WEEK) *
      POULTRY_TIMELINE_PHONE_WEEK
    : initialDay * dayWidth;
  const initialScrollLeft = Math.max(0, Math.min(width - contentWidth, initialTarget));
  return {
    windowStart: window.start,
    windowEnd: window.end,
    end,
    totalDays,
    canvasWidth,
    dayWidth,
    dateWidth,
    width,
    initialScrollLeft,
  };
}

export function poultryTimelineMonths(start: string, end: string) {
  const month = new Date(`${start.slice(0, 7)}-01T00:00:00Z`);
  const months: {date: string; label: string}[] = [];
  while (month.toISOString().slice(0, 10) < end) {
    const date = month.toISOString().slice(0, 10);
    months.push({
      date: date < start ? start : date,
      label: month.toLocaleDateString('en-US', {month: 'short', year: 'numeric', timeZone: 'UTC'}),
    });
    month.setUTCMonth(month.getUTCMonth() + 1);
  }
  return months;
}
